// extracted by mini-css-extract-plugin
export default {"content":"Choice__content--2RMjg","title":"Choice__title--3DxCt"};